<template>
  <app-page-section
    class="relative xl:px-4 xl:pb-[10vh]"
    :subtitle="{
      tag: 'h2',
      text: 'Formations intra entreprise ou programmes sur mesure',
    }"
    :title="{ tag: 'p', text: 'Deux façons de former vos équipes' }"
  >
    <div v-if="width > 1080" class="-mt-6 mb-8 grid place-content-center">
      <app-button
        class="!text-subtle"
        variant="link"
        @click="comparisonDialog.open()"
      >
        Comparer nos offres
      </app-button>
    </div>

    <app-image
      alt=""
      aria-hidden="true"
      class="absolute bottom-0 left-0 hidden aspect-[3] w-full rounded-2xl object-cover object-top xl:block"
      src="https://res.cloudinary.com/dfdgwwkpd/image/upload/v1728894772/brand/enterprise/d9079a5742bb511590e3adcfdb6dd310_1_jcqsyv.jpg"
    />

    <div
      class="border-primary/15 bg-primary-50 relative mx-auto grid max-w-[1300px] overflow-hidden rounded-2xl border-2 bg-clip-padding shadow-lg lg:grid-cols-2"
    >
      <enterprise-page-offer-card
        v-for="offer in list"
        :key="offer.id"
        class="p-6 sm:p-12"
        :offer="offer"
      />
    </div>
  </app-page-section>
</template>

<script lang="ts" setup>
import EnterprisePageOfferCard from "~/pages/enterprise/_includes/components/enterprise-page-offer-card.vue";

const { width } = useWindowSize();
const { list } = useOfferList();

const comparisonDialog = useDialog("offerComparisonDialog");
</script>
